import * as types from '../constants/chartConstants';

export function loadChart() {
  const timeUnit = 300;
  const symbol = '1';
  return {
    type: types.LOAD_CHART,
    promise: (client) => client.get(`/chart?symbol=${symbol}&side=1&timeUnit=${timeUnit}&unitSpan=50`, {}),
    timeUnit
  };
}

export function lineChartData(side, cmdtyId, queryParamString, uniqueId, defAcc) {
  //.log("side "+side+" IID "+cmdtyId+" queryParamString "+queryParamString+" uniqueId "+uniqueId);
  const accountCode = defAcc;
  return {
    type: types.LINE_CHART,
    queryParamString,
    uniqueId,
    promise: (client) => client.post('/fetchGraphRates', {
      data: {
      IID:cmdtyId,
      AC:accountCode,
      ST_DAY:"1"
    }})
    };
}

export function candleChartData(side, cmdtyId, queryParamString, uniqueId, defAcc) {

  const accountCode = defAcc;
  return {
    type: types.CANDLESTICK_CHART,
    queryParamString,
    uniqueId,
    promise: (client) => client.post('/candleStickChart', {
      data: {
      IID:cmdtyId,
      AC:accountCode
    }})
  };
}

// export function CandleStickData(side, symbol, queryParamString, uniqueId) {
//   const accountCode = JSON.parse(localStorage.getItem('DFA')).C;
//   let intervalType = 1;
//   return {
//     types: [types.CANDLESTICK_CHART, types.CANDLESTICK_CHART_SUCCESS, types.CANDLESTICK_CHART_FAILURE],
//     promise: (client) => client.get(`trader/candleStickChart?symbol=${symbol}&side=${side}&accountCode=${accountCode}&interval=${intervalType}`, {}),
//     queryParamString,
//     uniqueId
//   };
// }

export function historicalChartData(symbol, startDate, endDate, queryParamString, uniqueId) {
  const accountCode = JSON.parse(localStorage.getItem('DFA')).C;
  return {
    type: types.HISTORICAL_CHART, 
    promise: (client) => client.post('/fetchChartHistory', {
      data: {
        IID: symbol,
        AC: accountCode,
        FD: startDate,
        TD: endDate
      }}),
    queryParamString,
    uniqueId
  };
}

export function updateLocalstorage() {
  return {
    type: types.LOCAL_STORAGE_UPDATED
  }
}
